
import Vue from "vue";
import { View } from "@/models/view";

export default Vue.extend({
	data(){
		return {
			duplicateView: null as View | null
		};
	},
	props: {
		view: {
			type: Object as () => View,
			required: true
		}
	},
	computed: {
		isSet(): boolean {
			if (this.duplicateView) {
				return true;
			}
			return false;
		},
	},
	methods: {
		close(){
			this.$emit("close");
		},
		duplicate(){
			if (this.duplicateView != null && this.duplicateView.Name != "") {
				this.$emit("duplicateView", this.duplicateView);
				return;
			}
			this.$wf.notify(this.$ct("common.filters.computed.is null",{prop: "Naam"}).toString(), "warning", 3500, "exclamation-triangle");
		}
	},
	mounted(){
		if (this.view) {
			this.duplicateView = new View(this.view);
			this.duplicateView.Name = "";
		}
	}
});
